import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export interface IIsDuplicateBimehNamehShakhsSalesInOrderQuery {
  shomarehEntezami1?: string | null;
  shomarehEntezami2?: string | null;
  shomarehEntezami3?: string | null;
  serialPelak?: string | null;
}

export interface IIsDuplicateBimehNamehShakhsSalesInOrderQr {
  isExists?: boolean | null;
  orderId?: number | null;
}

const isDuplicateBimehNamehShakhsSalesInOrder = createAsyncThunk(
  'ShakhSalesBimehNameh/isDuplicateBimehNamehShakhsSalesInOrder',
  async (query: IIsDuplicateBimehNamehShakhsSalesInOrderQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.IsDuplicateBimehNamehShakhsSalesInOrder}`,
      params: query,
    });
  }
);

export default isDuplicateBimehNamehShakhsSalesInOrder;
